import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_NextSottoProgettoTable = _resolveComponent("NextSottoProgettoTable")!

  return (_openBlock(), _createBlock(_component_NextSottoProgettoTable, {
    class: "rotate-x-180 w-full border-separate",
    actionClass: "relative",
    nuvola_td_class: "border-next-light-gray",
    alternativa_td_class: "border-next-light-gray",
    seleectable: true,
    cols: _ctx.TableHeader,
    "onUpdate:cols": _ctx.syncUserPreference,
    rows: _ctx.ordered_records
  }, _createSlots({ _: 2 }, [
    _renderList(_ctx.ordered_records, (rc, i) => {
      return {
        name: `td_${i}_preactions`,
        fn: _withCtx(({row}) => [
          _renderSlot(_ctx.$slots, `td_${i}_preactions`, _normalizeProps(_guardReactiveProps({row: row})))
        ])
      }
    }),
    _renderList(_ctx.rowCellIterator(_ctx.ordered_records, _ctx.sottoProgettiCols), (rc, x) => {
      return {
        name: `td_${rc}`,
        fn: _withCtx(({row, cell}) => [
          _createVNode(_component_Text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.getValue(row, cell)), 1)
            ]),
            _: 2
          }, 1024)
        ])
      }
    })
  ]), 1032, ["cols", "onUpdate:cols", "rows"]))
}